import React from "react";
import { Link } from "react-router-dom";

function arrayBufferToBase64(buffer) {
  var binary = "";
  var bytes = [].slice.call(new Uint8Array(buffer));
  bytes.forEach((b) => (binary += String.fromCharCode(b)));
  return window.btoa(binary);
}

export default function BatteryCardRender({ item }) {
  var base64Flag = "data:image/jpeg;base64,";
  var imageStr = arrayBufferToBase64(item.image.data.data);
  var img = base64Flag + imageStr;

  return (
    <div className="battery__card" key={item._id}>
      <img className="battery__image" src={img} alt="" />
      <div className="battery__details">
        <span>{item.name}</span> <br />
        <span>{item.model}</span>
        <br />
        <span>Warrenty:{item.warrenty} Months</span>
        <br />
        <span>Price : INR {item.price}.00</span>
        <br />
      </div>
      <Link to="/products/About">
        <button className="battery__order_btn">ORDER NOW</button>
      </Link>
    </div>
  );
}
